import React from 'react';
import { IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type CustomNotificationType = {
    message: string,
    isOpen: boolean,
    onClose: Function
}

const CustomNotification = (props: CustomNotificationType) => {

    const defaultDuration = 5000;

    const action = (
        <React.Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => {props.onClose()}}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );

    return (
        <>
            <Snackbar
                open={props.isOpen}
                autoHideDuration={defaultDuration}
                onClose={() => { props.onClose() }}
                message={props.message}
                action={action}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            />
        </>
    )
}

export default CustomNotification;